import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SessionActionCreator from '../../actions/SessionActionCreator';
import InternetBankingActions from '../../actions/InternetBankingActions';
import envConfig from '../../../static/config';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import SessionStore from '../../stores/SessionStore';
import UserManagementStore from '../../stores/UserManagementStore';
import api from '../../utils/Api';
import HashcodeUtils from '../../utils/HashcodeUtils';
import MoveMoneyApiUtils from '../../utils/MoveMoneyApiUtils';
import HardTokenChallengeLib from 'hard-token-challenge-lib';

const getBrand = (brandId) => {
  const brand = {
    CB: 'CB',
    YB: 'YB',
    DYB: 'B',
    VM: 'VM',
  };

  return brand[brandId.toUpperCase()];
};

export default class VerificationContainer extends Component {
  constructor(props) {
    super(props);

    this.handleCancel = this.handleCancel.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleFail = this.handleFail.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);

    this.state = {
      clientContext: api.clientContext(),
      accessToken: SessionStore.getToken().access_token,
      apiUrl: envConfig.apiBaseUrl,
      PAASUrl: envConfig.apiBaseUrlPAAS,
      bankId: SessionStore.getSessionBankID(),
      brand: getBrand(envConfig.brandId),
      verificationId: HashcodeUtils.getSourceIdForSoftToken(),
      isSMEUser: UserManagementStore.isSMEUser(),
    };
  }

  handleCancel() {
    MoveMoneyApiUtils.isSourceIdSame(false);
    MoveMoneyStore.setInReviewFlag(false);
    MoveMoneyStore.refreshPaymentResponse();
    this.props.onCancel();
  }

  handleError() {
    InternetBankingActions.navigateToWebTask('WEB-ERROR');
  }

  handleFail() {
    SessionActionCreator.requestAccessTokenReset(true);
  }

  handleSuccess() {
    /**
     * Sets useSoftTokenSourceId to true, which causes payment call to use existing sourceId the next time it is called.
     * payments call is made in the componentWillReceiveProps method of ReviewPage if makePaymentCall prop set to true.
     * makePaymentCall is a state value of MoveMoneyFromToComponent set within the onSuccess handler below.
     **/
    MoveMoneyApiUtils.isSourceIdSame(true);
    this.props.onSuccess();
  }

  render() {
    const { verificationId, isSMEUser, ...config } = this.state;

    return (
      <div className="web-ui-components">
        <HardTokenChallengeLib
          config={{ ...config }}
          exitApp={this.handleCancel}
          onError={this.handleError}
          onFail={this.handleFail}
          onSuccess={this.handleSuccess}
          verificationId={verificationId}
          isSme={isSMEUser}
        />
      </div>
    );
  }
}

VerificationContainer.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};
